﻿import {writable} from "svelte/store";
import type {RouteMeasurements} from "../models/route-measurements.model";

export const routeMeasurementsMappedStore = writable<RouteMeasurements[]>([]);